import { compose } from 'lodash/fp';
import { connect } from 'react-redux';
import { injectStripe } from 'react-stripe-elements';

import { Payment } from '../../models/payment.model';
import { State } from '../../models/state.model';
import {
  getInvoice,
  selectInvoice,
  selectInvoiceAttachment,
  selectInvoiceAuth,
  selectInvoiceError,
  selectInvoiceLogo,
  selectInvoiceMerchant,
  selectPaymentLoading,
  selectPaymentSuccess,
  selectDeclined,
  submitPayment,
} from '../../redux/actions/payment/payment.action';
import { PaymentPage } from './payment-page/payment-page.component';

export const PaymentPageContainer = compose(
  injectStripe,
  connect(
    (state: State, ownProps: { uniqueLink: string; stripe: any }) => ({
      error: selectInvoiceError(state),
      invoice: selectInvoice(state),
      logo: selectInvoiceLogo(state),
      stripe: ownProps.stripe,
      success: selectPaymentSuccess(state),
      uniqueLink: ownProps.uniqueLink,
      merchant: selectInvoiceMerchant(state),
      attachment: selectInvoiceAttachment(state),
      auth: selectInvoiceAuth(state),
      loading: selectPaymentLoading(state),
      declined: selectDeclined(state),
    }),
    (dispatch) => ({
      getInvoice: (uniqueLink: string, birthdate: string) =>
        dispatch(getInvoice({ uniqueLink, birthdate })),
      submitPayment: (
        invoiceId: string,
        payment: Payment,
        complete?: (reason?: 'success' | 'fail' | 'unknown') => void
      ) => dispatch(submitPayment({ invoiceId, payment, complete })),
    })
  )
)(PaymentPage);
